import { combineReducers } from '@reduxjs/toolkit';

import { dexApi } from '../actions/dex';

const placeholder = (state = {}) => state;

export default combineReducers({ placeholder });

export const dexApis = [dexApi] as const;
